// Replace any placeholder with your exact ObjectIds from DB screenshots.
import Best_Seller from "../assets/megaMenu/bestseller.jpg"
import Trending from "../assets/megaMenu/Trending.jpg"
import Glasses from "../assets/megaMenu/glasses.jpg"
import Sunglasses from "../assets/megaMenu/sunglsses.jpg"
import Contact_Lens from "../assets/megaMenu/contactLens.avif"
import Contact from "../assets/megaMenu/contact.avif"
import KIDS_GLASSES from "../assets/megaMenu/kidsglasses.jpg"
import Banner1 from "../assets/megaMenu/1st.png"
import Banner2 from "../assets/megaMenu/2nd.jpg"
import Banner3 from "../assets/megaMenu/3rd.png"
import Banner4 from "../assets/megaMenu/4th.png"
import Aviator from "../assets/megaMenu/Aviator Frame.webp"
import Round from "../assets/megaMenu/Round Frame.webp"
import Rectangle from "../assets/megaMenu/Rectangle Frame.webp"
import Cat_Eye from "../assets/megaMenu/Cat-Eye Frame.avif"
import Oval from "../assets/megaMenu/Oval Frame.webp"
import Square from "../assets/megaMenu/Square Frame.jpg"


export const CAT = {
    sunglasses: "6915705d9ceac0cdda41c83f",
    glasses: "69157332eeb23fa59c7d5326",
    contact_lenses: "6915735feeb23fa59c7d532b",
};

export const SUB = {
    // glasses
    mens: "691574b0eeb23fa59c7d5334",
    women: "69157614eeb23fa59c7d533b",
    kids: "6915763ceeb23fa59c7d5342",
    transitions: "69157665eeb23fa59c7d5349",
    blue_violet: "69157694eeb23fa59c7d5350",
    progressive: "691576ddeeb23fa59c7d5357",


    // sunglasses
    mens: "69157706eeb23fa59c7d536a",
    women: "6915771feeb23fa59c7d5371",
    kids: "69157748eeb23fa59c7d5378",
    prescription: "6915778ceeb23fa59c7d537f",
    polarized: "691577b5eeb23fa59c7d5386",



    // contact lenses
    single_vision: "69157803eeb23fa59c7d538d",
    multifocal: "69157823eeb23fa59c7d5394",
    toric: "6915785beeb23fa59c7d539b",
    coloured: "69157878eeb23fa59c7d53a2",
};


export const SUB_IMG = {
    MENS_FRAME: "1758131292251-147426517.jpeg",
    WOMENS_FRAME: "1758131302448-346075440.jpeg",
    CONTACT_LENSE: "1758131283034-305996444.jpeg",
    EYEGLASSES: Glasses,
    SUNGLASSES: Sunglasses,
    KIDS_GLASSES: KIDS_GLASSES,
    AVIATOR: Aviator,
    ROUND: Round,
    RECTANGLE: Rectangle,
    CAT_EYE: Cat_Eye,
    OVAL: Oval,
    SQUARE: Square,
    SPORTS_GLASSES: "1758131214858-622328976.jpg",
    BLUE_GLASSES: "1758131248363-676470511.jpg",
    SUNGLASSES2: Sunglasses,
    GLASSES: Glasses,
    Best_Seller: Best_Seller,
    Trending: Trending,
    Contact_Lens: Contact_Lens,
    Contact_Lens2: Contact,
    Banner1: Banner1,
    Banner2: Banner2,
    Banner3: Banner3,
    Banner4: Banner4,
}
